import { useEffect, useRef, useState } from "react";
import { subscribeVideoElement } from "../lib/videoTokenRegistry";

// Returns the live <video> element for a LiveKit identity (or null) and keeps the given
// Konva node's layer redrawing every frame while it's active, since Konva doesn't know a
// video element's pixels are changing on their own.
export function useVideoTokenElement(identity, nodeRef) {
  const [videoEl, setVideoEl] = useState(null);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!identity) {
      setVideoEl(null);
      return;
    }
    return subscribeVideoElement(identity, setVideoEl);
  }, [identity]);

  useEffect(() => {
    if (!videoEl) return;
    const tick = () => {
      const layer = nodeRef.current?.getLayer();
      if (layer) layer.batchDraw();
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [videoEl, nodeRef]);

  return videoEl;
}
